import React from 'react';
import {AppRoutes} from "./components/routing/AppRoutes";
import NavBar from "./components/nav/nav-bar/NavBar";

function App() {

  return (
      <div>
        <NavBar/>
        <main>
          <AppRoutes/>
        </main>
      </div>
  );
}

export default App;
